import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoAttantion = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9.224 29C7.237 29 6 27.555 6 25.756c0-.55.148-1.112.454-1.651l8.787-15.477A3.13 3.13 0 0 1 18 7c1.078 0 2.146.55 2.759 1.628l8.787 15.477c.295.527.454 1.1.454 1.65 0 1.8-1.249 3.245-3.224 3.245zm.193-2.155h17.154c.704 0 1.158-.562 1.158-1.193a1.4 1.4 0 0 0-.159-.642L18.977 9.82c-.215-.378-.601-.539-.976-.539s-.772.16-.988.54L8.418 24.987a1.5 1.5 0 0 0-.147.664c0 .631.431 1.193 1.146 1.193M18 21.078c-.636 0-.988-.367-1.01-1.009l-.16-5.594c-.022-.665.466-1.135 1.159-1.135.692 0 1.192.481 1.169 1.146l-.17 5.572c-.012.665-.375 1.02-.988 1.02m0 3.795c-.727 0-1.328-.539-1.328-1.261 0-.711.601-1.25 1.328-1.25.738 0 1.328.528 1.328 1.25s-.601 1.26-1.328 1.26"
	})
});
export default SvgIcoAttantion;
